"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var pendingInvitesSlice_1 = __importDefault(require("@features/SettingsPage/state/pendingInvitesSlice"));
var memberSlice_1 = __importDefault(require("@features/SettingsPage/state/memberSlice"));
var settingsSlice_1 = __importDefault(require("@features/SettingsPage/state/settingsSlice"));
var moderationSettingsSlice_1 = __importDefault(require("@features/SettingsPage/state/moderationSettingsSlice"));
var dataStoringSlice_1 = __importDefault(require("@features/SettingsPage/state/dataStoringSlice"));
var orchestrationSlice_1 = __importDefault(require("@features/SettingsPage/state/orchestrationSlice"));
var deleteContentSlice_1 = __importDefault(require("@features/SettingsPage/state/deleteContentSlice"));
var trustedDomainsSlice_1 = __importDefault(require("@features/SettingsPage/state/trustedDomainsSlice"));
var currentTeamSettingsReducer = (0, toolkit_1.combineReducers)({
    pendingInvites: pendingInvitesSlice_1.default,
    members: memberSlice_1.default,
    moderationSettings: moderationSettingsSlice_1.default,
    teamSettings: settingsSlice_1.default,
    orchestrationSettings: orchestrationSlice_1.default,
    dataStoring: dataStoringSlice_1.default,
    deleteContent: deleteContentSlice_1.default,
    trustedDomains: trustedDomainsSlice_1.default,
});
exports.default = currentTeamSettingsReducer;
